















import { Vue } from "vue-property-decorator";
import LineChart from "./LineChart.js";

export default Vue.extend({
  components: {
    LineChart
  },
  data() {
    return {
      msg: "💹 My Progress"
    };
  }
});
